import { AppBarComponent } from '@syncfusion/ej2-react-navigations'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import dayjs from 'dayjs'
import { useAppSelector } from '../../hooks/reduxHooks.tsx'

export const Footer = () => {
  const externeURL = 'https://www.kbw.de/impressum'
  const profile = useAppSelector(state => state.register.selectedRegistration)
  const handleNavigation = () => {
    window.location.href = externeURL
  }
  return (
    <footer>
      <AppBarComponent colorMode={'Dark'} className="footerBar">
        <span> &copy; KBW e.V. Alle Rechte vorbehalten.</span>
        <div className="e-appbar-spacer"></div>
        <div style={{ display: 'flex', flexDirection: 'row', marginRight: '5px' }}>Letzter Login: {profile && dayjs(profile.lastLogin).format('DD.MM.YYYY - HH:mm')}</div>
        <ButtonComponent cssClass="e-inherit navBtn" onClick={handleNavigation}>
          Impressum
        </ButtonComponent>
      </AppBarComponent>
    </footer>
  )
}
